import * as CommunicationCurrentStatus from 'src/constants/communication-current-status'
import * as CommunicationDispositionStatus from 'src/constants/communication-disposition-status'

/**
 * Whether a communication still counts as a parked call.
 *
 * Mirrors api-core's `scopeParkedCalls`, which requires the call to be on hold
 * AND still in progress. Shared by the parked-call mixin (which owns the
 * `parkedCalls` list) and the dialer (which owns the single `dialer.parkedCall`
 * slot and its timer) so the two surfaces cannot disagree about whether a box
 * should still be on screen.
 *
 * Assumes a complete payload: a missing key reads as not-parked. Every current
 * caller is fed `CommunicationResource::toCompleteArray()`, which always sends
 * both fields — evaluate this against the raw broadcast rather than a merged
 * copy, or an omitted key silently resolves to the previous value.
 *
 * @param {{ current_status2: number, disposition_status2: number }} communication
 * @returns {boolean}
 */
export function isStillParked (communication) {
  return communication.current_status2 === CommunicationCurrentStatus.CURRENT_STATUS_HOLD_NEW &&
    communication.disposition_status2 === CommunicationDispositionStatus.DISPOSITION_STATUS_INPROGRESS_NEW
}
